module.exports = window.TARO;